// libs
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';

// component
import VideoModal from '../../../layouts/modal/videoModal/VideoModal';

// actions
import modalActions from '../../../../actions/modal';

// Props and Context
const propTypes = {
  children: PropTypes.node.isRequired,
  resourceType: PropTypes.string.isRequired,
  showModal: PropTypes.func.isRequired,
  url: PropTypes.string,
  video: PropTypes.object,
};

const defaultProps = {
  url: '',
  video: {},
};

const contextTypes = {
  t: PropTypes.func,
};

function ResourceCardAction(props) {
  const { url, children, resourceType, showModal, video } = props;
  return (
    resourceType === 'video' ? (
      <button
        className={classNames(
          'card__link',
          `card__link--${video.type ? video.type : 'video'}`,
        )}
        onClick={() => showModal(
          VideoModal,
          props,
        )}
      >
        {children}
      </button>
    ) : (
      <a href={url} target="_blank">
        {children}
      </a>
    )
  );
}

ResourceCardAction.contextTypes = contextTypes;
ResourceCardAction.propTypes = propTypes;
ResourceCardAction.defaultProps = defaultProps;

export default connect(null, modalActions)(ResourceCardAction);



// WEBPACK FOOTER //
// ./src/app/components/cards/card/cardActions/ResourceCardAction.js